<template>
  <div>
    <template v-if="showBiometria">
      <anexos-wrapper ref="biometria" nome="Biometrias" entidade="INDICADOR_PESSOAL_CAPTURA_BIOMETRIA"
                      :permiteExcluirAnexo="permitirExcluirFingerprint"
                      :id="pessoa.indicadorPessoalId" :exibirBotoes="false" >
        <template #menu>
          <button v-if="permitirCapturarFingerprint" style="margin-top: -12px; margin-right: 10px;" class="btn btn-sm btn-outline-info pointer float-right" @click="capturarBiometria">Capturar Biometria</button>
        </template>
      </anexos-wrapper>
    </template>
    <template v-if="showImagem">
      <anexos-wrapper ref="anexos" nome="Imagens" entidade="INDICADOR_PESSOAL_CAPTURA"
                      :permiteExcluirAnexo="permitirExcluir"
                      :id="pessoa.indicadorPessoalId" :exibirBotoes="false" >
        <template #menu>
          <button v-if="permitirCapturar" style="margin-top: -12px;" class="btn btn-sm btn-outline-info pointer float-right" @click="capturar">Capturar Imagem</button>
        </template>
      </anexos-wrapper>
    </template>

    <template v-if="showAssinatura && isAtribuicaoNotas">
      <anexos-wrapper ref="assinatura" nome="Assinatura" entidade="INDICADOR_PESSOAL_CAPTURA_ASSINATURA" classTitle="d-flex justify-content-between align-items-center"
                      :id="pessoa.indicadorPessoalId"
                      accept="image/*,.pdf"
                      :extensions="['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'pdf']"
                      :multiple="true"
                      :baixarLote="false"
                      :exibirBotoes="permitirAdicionarAssinatura"
                      :permiteExcluirAnexo="permitirExcluirAssinatura"/>
    </template>

  </div>
</template>

<script>

import FrontBusiness from "@/business/FrontBusiness";
import Biometria from "@/components/IndicadorPessoal/Detalhes/Biometria/Biometria.vue";
import Imagem from "@/components/IndicadorPessoal/Detalhes/BiometriaImagem/Imagem.vue";
import AnexosWrapper from "@/components/Anexos/AnexosWrapper.vue";

export default {
  name: "BiometriaImagem",
  components: {AnexosWrapper},
  props: {
    pessoa: Object,
    tipo: String,
  },

  data() {
    return {
      postUrl: null,
      loading: false,
      files: [],
    }
  },

  mounted() {

  },

  computed: {
    permitirCapturar(){
      return this.$root.getPermission({id: 'PERMITIR_CAPTURAR_IMAGEM_INDICADOR_PESSOAL'});
    },
    permitirExcluir(){
      return this.$root.getPermission({id: 'PERMITIR_EXCLUIR_IMAGEM_INDICADOR_PESSOAL'});
    },
    permitirCapturarFingerprint(){
      return this.$root.getPermission({id: 'PERMITIR_CAPTURAR_FINGERPRINT_INDICADOR_PESSOAL'});
    },
    permitirExcluirFingerprint(){
      return this.$root.getPermission({id: 'PERMITIR_EXCLUIR_FINGERPRINT_INDICADOR_PESSOAL'});
    },
    isAtribuicaoNotas(){
      return this.$root.isNotas;
    },
    permitirAdicionarAssinatura(){
      return this.$root.getPermission({id: 'PERMITIR_ADICIONAR_ASSINATURA_INDICADOR_PESSOAL'});
    },
    permitirExcluirAssinatura(){
      return this.$root.getPermission({id: 'PERMITIR_EXCLUIR_ASSINATURA_INDICADOR_PESSOAL'});
    },
    entidade() {
      return "INDICADOR_PESSOAL_CAPTURA_ASSINATURA";
    },

    showAssinatura() {
      return !this.tipo || this.tipo.toLowerCase() === 'assinatura'
    },

    showBiometria() {
      return !this.tipo || this.tipo.toLowerCase() === 'biometria'
    },

    showImagem() {
      return !this.tipo || this.tipo.toLowerCase() === 'imagem'
    }
  },

  methods: {
    async capturar() {
      await FrontBusiness.openModal(Imagem, {id: this.pessoa.indicadorPessoalId})
      this.$refs.anexos.load();
    },
    async capturarBiometria() {
      await FrontBusiness.openModal(Biometria, {id: this.pessoa.indicadorPessoalId})
      this.$refs.biometria.load();
    },
    load() {
      this.$refs.assinatura.load();
    }
  }
}
</script>

<style lang=scss>
.upload-align {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 4px 6px;
  font-size: 14px;
  line-height: 1;
  border-radius: 4px;
}
</style>
